import Vue from 'vue'

window.EventBus = new Vue()